<template>
  <el-dialog
    title="批量恢复不断货"
    :visible.sync="batchRecoverDialogVisible"
    width="90%"
    :before-close="handleBatchRecoverDialogClose"
  >
    <el-row>
      <el-col>
        <el-form ref="form" :model="form" :inline="true">
          <el-form-item class="_form-item">
            <el-select
              v-model="form.supply_id"
              filterable
              clearable
              remote
              :remote-method="fetchSupply"
              placeholder="商家"
            >
              <el-option
                v-for="item in options.supply"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-input
              v-model="form.goods_no"
              placeholder="货号"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="form.goods_kh_like"
              clearable
              placeholder="款号"
            ></el-input>
          </el-form-item>

          <el-form-item label-width="0">
            <el-button @click="handleReset">重置</el-button>
          </el-form-item>
          <el-form-item label-width="0">
            <el-button type="primary" @click="handleSearch"> 查询 </el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-table
      ref="recoverTable"
      :data="resData.list"
      style="width: 100%"
      max-height="600px"
    >
      <el-table-column align="center" prop="supply_name" label="商家">
      </el-table-column>
      <el-table-column align="center" prop="goods_img" label="商品图片">
        <template #default="scope">
          <div
            v-viewer
            style="
              width: 40px;
              height: 40px;
              overflow: hidden;
              cursor: pointer;
              margin: auto;
            "
          >
            <img style="width: 100%; height: 100%" :src="scope.row.main_img" />
          </div>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="商品名称"
        prop="goods_name"
      ></el-table-column>
      <el-table-column
        align="center"
        label="货号"
        prop="goods_no"
      ></el-table-column>
      <el-table-column
        align="center"
        label="款号"
        prop="goods_kh"
      ></el-table-column>
      <el-table-column align="center">
        <div slot="header">
          <div>计划单号/</div>
          <div>计划生成时间</div>
        </div>
        <template #default="{ row }">
          <div>{{ row.planid }}</div>
          <div>{{ row.create_time }}</div>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="计划代采单价"
        prop="plan_price"
      ></el-table-column>
      <el-table-column
        align="center"
        label="颜色"
        prop="co_val"
      ></el-table-column>
      <el-table-column
        align="center"
        label="尺码"
        prop="si_val"
      ></el-table-column>
      <el-table-column align="center" prop="num" label="急救箱">
        <template #default="scope">
          <el-button type="text" @click="toggleNum(scope.row)">{{
            scope.row.num
          }}</el-button>
        </template>
      </el-table-column>
      <el-table-column align="center" label="恢复不断货" width="240px">
        <template #default="scope">
          <YsInput
            v-model="scope.row.recoverNum"
            pattern="digit"
            style="width: 80%"
            :clearable="false"
            :max="scope.row.initNum"
            @blur="handleChangeRecoverNum(scope.row, 'blur')"
          >
            <el-button
              slot="prepend"
              :disabled="scope.row.recoverNum <= 0"
              @click="handleChangeRecoverNum(scope.row, 'decrease')"
              >-</el-button
            >
            <el-button
              slot="append"
              :disabled="scope.row.recoverNum >= scope.row.initNum"
              @click="handleChangeRecoverNum(scope.row, 'increase')"
              >+</el-button
            >
          </YsInput>
        </template>
      </el-table-column>
    </el-table>
    <div slot="footer" class="dialog-footer">
      <span
        >已选{{ selected }}款，{{ quantity }}件，共计￥{{ toTalMoney }}</span
      >
      <el-button @click="handleResetRecoverNum">重置</el-button>
      <el-button @click="handleSelectAll">全选</el-button>
      <el-button type="primary" @click="handleConfirmBatchRecover"
        >确定恢复不断货</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import {
  postBatchCancelOutOfStockGoodsList,
  postBatchCancelOutOfStock,
} from "@/openapi/erp/wcgPlanCancel.js";
import { calculateExpression } from "@/utils/math.js";

export default {
  data() {
    return {
      batchRecoverDialogVisible: false,
      tableLoading: false,
      form: {
        goods_no: "",
        goods_kh_like: "",
        supply_id: "",
      },
      resData: {
        list: [],
      },
      initList: [],
      options: {
        supply: [],
      },
      selected: 0, // 款数
      quantity: 0, // 件数
      toTalMoney: 0, // 总金额
    };
  },
  created() {
    // this.fetchData();
  },

  methods: {
    updateStatistics() {
      const selectedList = this.resData.list.filter(
        (item) => Number(item.recoverNum) > 0
      );
      const selectedSet = new Set(selectedList.map((item) => item.goods_no));
      this.selected = selectedSet.size;
      this.quantity = this.resData.list.reduce(
        (acc, item) => calculateExpression(`${acc} + ${item.recoverNum}`, 0),
        0
      );
      const _toTalMoney = this.resData.list.reduce(
        (acc, item) =>
          calculateExpression(
            `${acc} + ${item.plan_price * item.recoverNum}`,
            2
          ),
        0
      );
      this.toTalMoney = _toTalMoney;
    },
    showModal() {
      this.fetchData();
      this.selected = 0;
      this.quantity = 0;
      this.toTalMoney = 0;
      this.batchRecoverDialogVisible = true;
    },
    fetchData() {
      this.tableLoading = true;
      postBatchCancelOutOfStockGoodsList()
        .then((res) => {
          this.initList = res.list.map((item) => {
            return { ...item, recoverNum: 0, initNum: Number(item.num) };
          });
          this.$set(this.resData, "list", [...this.initList]);
          this.tableLoading = false;
        })
        .catch((err) => {
          console.log("postBatchCancelOutOfStockGoodsList err: ", err);
        });
    },
    // 远程搜索商家
    fetchSupply(e) {
      this.$http
        .post("/erp/Common/fetchSupplyBySearch", { supply_name: e })
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          }
          this.options.supply = res.data.data;
        });
    },
    handleConfirmBatchRecover() {
      const _list = this.resData.list.filter((item) => {
        return item.recoverNum > 0;
      });
      const list = _list.map((item) => {
        return {
          id: item.planinfoid,
          num: item.recoverNum.toString(),
        };
      });
      postBatchCancelOutOfStock({ cancel_data: list })
        .then(() => {
          this.$message.success("操作成功");
          this.batchRecoverDialogVisible = false;
        })
        .catch((err) => {
          console.log("postBatchCancelOutOfStock err: ", err);
        });
    },
    handleReset() {
      this.form = this.$options.data().form;
      this.handleSearch();
    },
    handleResetRecoverNum() {
      for (const item of this.resData.list) {
        item.recoverNum = 0;
        item.num = item.initNum;
      }
      this.updateStatistics();
    },
    handleBatchRecoverDialogClose() {
      this.form = this.$options.data().form;
      this.batchRecoverDialogVisible = false;
    },
    handleSearch() {
      const filteredList = this.initList.filter((item) => {
        // 根据表单中的属性值进行筛选
        const isGoodsNoMatch = this.form.goods_no.trim()
          ? item.goods_no.indexOf(this.form.goods_no) !== -1
          : true;
        const isGoodsKhLikeMatch = this.form.goods_kh_like.trim()
          ? item.goods_kh.indexOf(this.form.goods_kh_like) !== -1
          : true;
        const isSupplyIdMatch = this.form.supply_id.trim()
          ? item.supply_id === this.form.supply_id
          : true;

        return isGoodsNoMatch && isGoodsKhLikeMatch && isSupplyIdMatch;
      });
      this.$set(this.resData, "list", filteredList);
    },

    handleChangeRecoverNum(row, action) {
      const _num = row.initNum;
      if (action === "blur" && row.recoverNum >= _num) {
        row.num = 0;
        this.updateStatistics();
        return;
      }
      if (action === "decrease" && row.recoverNum > 0) {
        row.recoverNum--;
      } else if (action === "increase" && row.recoverNum < _num) {
        row.recoverNum++;
      }
      if (row.recoverNum <= _num) {
        row.num = _num - row.recoverNum;
      }
      this.updateStatistics();
    },
    handleSelectAll() {
      for (const item of this.resData.list) {
        item.recoverNum = item.initNum;
        item.num = 0;
      }
      this.updateStatistics();
    },
    toggleNum(row) {
      if (row.num > 0) {
        row.num = 0;
        row.recoverNum = row.initNum;
      } else {
        row.num = row.initNum;
        row.recoverNum = 0;
      }
      this.updateStatistics();
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/pages/firstAidKit/components/BatchRecoverModal.vue